/**
 * helper that lets you know if you're on a small screen (one that is under 768 in width)
 *
 * @param viewportWidth
 * @returns {boolean}
 */
export const getIsSmallScreen = (viewportWidth) => {
	return viewportWidth < 768;
};
